import Modal from '../../../components/Modal'
import { memo } from "react"
import { DgtPdOrderOperation } from '../../../models'
import { OrderInspectionLog, OrderOperationLog } from '../../../components/types'

import Badge from "../../../components/Badge";

import RetainRecord from '../RetainRecord'
import { formatNumberV2 } from '../../../utilities/Format'
import FGInspectMenu from '../../../components/FGInspectMenu';
import { Button } from '@aws-amplify/ui-react'
import { AiOutlineReload } from 'react-icons/ai';

type SaveDraftDialogFGProps = {
  id: string
  show: boolean
  workCenter: DgtPdOrderOperation
  orderQty: number
  orderType: string
  material: string
  unit: string
  logs: OrderOperationLog[],
  fgInspectionLogs: OrderInspectionLog[],
  onCancel: () => void
  onConfirm: (id: string) => void
  isPreProduction?: boolean
  onReloadFGInspections?: () => void
}

const SaveDraftDialogFG = ({
  id, show, workCenter, orderQty, unit, onCancel, onConfirm, orderType, material, logs, fgInspectionLogs,
  isPreProduction = false,
  onReloadFGInspections
} : SaveDraftDialogFGProps) => {
  let totalYield = sumYield(logs)
  if (totalYield === 0) {
    totalYield = sumBulkUsed(logs)
  }
  const isRecordYield = totalYield > 0
  const isAllowSubmit = isRecordYield

  const operationDesc = `${workCenter.operationNo} - ${workCenter.actualWorkCenterDescription ? workCenter.actualWorkCenterDescription : workCenter.workCenterDescription} (${workCenter.actualWorkCenterId ? workCenter.actualWorkCenterId : workCenter.workCenterId})`

  const bulkUsedByBatch = sumBulkUsedByBatch(logs)  
  const loggedBatchNumbers = Object.keys(bulkUsedByBatch)
  return <Modal
    show={show}
    title={`ยืนยันการจบขั้นตอน : ${workCenter.productionOrderId} / ${operationDesc}`}
    cancelText={isAllowSubmit ? 'ยกเลิก' : 'ปิด'}
    onHide={onCancel}
    okText={isAllowSubmit ? 'ยืนยัน' : undefined}
    okTheme='success'
    okAction={() => onConfirm(id)}
    fullWidth={!isPreProduction}
    maxWidth={isPreProduction ? 'max-w-3xl' : ''}
    >
    {isAllowSubmit ? 
    <div>
      <div className='grid grid-cols-1 gap-3 md:grid-cols-4'>
        <div className='flex flex-col col-span-2'>
          <small className="font-bold">Material</small>
          <label className='font-light '>{material}</label>  
        </div>
        <div className='flex flex-col'>
          <small className="font-bold">Order Qty</small>
          <label className='font-light '>{formatNumberV2(orderQty)} {unit}</label>
        </div>
        <div className='flex flex-col'>
          <small className="font-bold">Order Type</small>
          <h6 className='basis-3/4 sm:basis-2/4 lg:basis-2/3'>
            {orderType === 'REPACK' && <Badge variant="order-repack"><>{orderType}</></Badge>}
            {orderType === 'CLAIM' && <Badge variant="order-claim"><>{orderType}</></Badge>}
            {orderType === 'FG' && <Badge variant="order-normal"><>{orderType}</></Badge>}
          </h6>
        </div>
      </div>
      <hr className='my-6 '/> 
      {isPreProduction ? 
      <div className='grid grid-cols-2 gap-3'>
        <div className={`flex flex-col items-center justify-center ${loggedBatchNumbers.length > 0 ? '':'col-span-2'} `}>
          <small>ผลิตได้รวม</small>
          <label className="text-4xl font-bold text-green-500">{formatNumberV2(totalYield)}<span className='text-sm font-normal text-muted'> {unit}</span></label>
        </div>
        {loggedBatchNumbers.length > 0 && <div className={`flex flex-col items-center justify-center`}>
          <small>Bulk ที่ใช้ผลิตไป</small>
          {loggedBatchNumbers.map(key =>
            <label key={key} className="text-lg font-bold">{key} = {
              formatNumberV2(bulkUsedByBatch[key].reduce((prev, cur) => prev + cur, 0))} KG.</label>
          )}
        </div>}
      </div>
      :
      <>
        <RetainRecord title='Order Receipt' disabledInput={true} />
        <div className='pt-3 space-y-5 '>
          <div className="flex gap-3 h-fit">
            <p className="text-xl font-bold ">สถานะใบตรวจคุณภาพ FG</p>
            <Button
              size='small'
              onClick={onReloadFGInspections}
              >
              <AiOutlineReload />
            </Button>
          </div>
          <div className='grid grid-cols-2 gap-3 lg:grid-cols-4'>
            {fgInspectionLogs.map(f => ({...f, canEdit: true })).map(form => (
              <FGInspectMenu
                key={`${form.inspectionType}-${form.id}`}
                formLog={form}
                hideArrow={true}
              />
            ))}
          </div>
        </div>
      </>
      }
    </div> : 
    <div>
      <label>ยังไม่มีการบันทึกข้อมูล</label>
    </div>}
  </Modal>
}

const sumYield = (logs: OrderOperationLog[]) => {
  return logs.reduce((prev, cur) => prev + (cur.yield ? cur.yield : 0), 0)
}

const sumBulkUsed = (logs: OrderOperationLog[]) => {
  return logs.reduce((prev, cur) => prev + (cur.bulkUsedQty ? cur.bulkUsedQty : 0), 0)
}
// Note : for soft go live stage, we will not use this function in grand opening.
const sumBulkUsedByBatch = (logs: OrderOperationLog[]) => {
  const filtered = logs.filter(log => log.bulkUsedQty && log.bulkUsedQty > 0);
  return filtered.reduce((rv, x) => {
    const batchNo = x.batchNo || 'unknown'; // Handle missing batchNo
    (rv[batchNo] = rv[batchNo] || []).push(x.bulkUsedQty || 0);
    return rv;
  }, {} as { [key: string]: number[] });
}

export default memo(SaveDraftDialogFG)